import React, { useCallback } from "react";
import { Checkbox, Label } from "@activecollab/components";
import classnames from "classnames";
import PropTypes from "prop-types";

export const FormCheckbox = ({ id, checked, onChange, className, text, disabled }) => {
  const handleClick = useCallback(() => {
    if (typeof onChange === "function") {
      onChange(!checked);
    }
  }, [checked, onChange]);

  return (
    <div
      data-testid="form-checkbox"
      className={classnames("tw-flex tw-flex-row", className)}
    >
      <Checkbox
        id={id}
        value={checked}
        onChange={handleClick}
        className="tw-mr-2"
        checked={checked}
        disabled={disabled}
      />
      <Label
        htmlFor={id}
        className="tw-self-center tw-cursor-pointer tw-select-none ds-color-900"
        weight="regular"
        size="small"
      >
        {text}
      </Label>
    </div>
  );
};

FormCheckbox.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  text: PropTypes.string.isRequired,
};

FormCheckbox.defaultProps = {
  checked: false,
  disabled: false,
};

FormCheckbox.displayName = "FormCheckbox";
